import { ROUTESWEB } from "@repo/utils";
import { decodeCyotId } from "@repo/tests-web";
import type { ModuleHandler, DeeplinkRoute } from "../types";
import { isILTSDeeplink } from "./iltsDeeplink";

export const testsHandler: ModuleHandler = (parsed): DeeplinkRoute | void => {
  const allParams = parsed.allParams ?? {};

  const cyotID = allParams.cyotID;
  const isFromDeepLinking = allParams.isFromDeepLinking;
  if (cyotID && isFromDeepLinking === "true") {
    const paperId = decodeCyotId(cyotID);
    if (paperId) {
      const grade = parsed.grade ? parseInt(parsed.grade, 10) : undefined;
      return {
        path: `/${ROUTESWEB.APP.TESTS}/cyot`,
        state: {
          sharedTest: {
            paperId,
            grade,
            examName: parsed.examName,
            examType: parsed.examType,
          },
        },
      };
    }
  }

  const examType = (parsed.examType ?? "").toLowerCase();

  if (isILTSDeeplink(parsed)) {
    return;
  }

  let subPath = "";
  if (examType === "ilts") {
    subPath = "/ilts";
  } else if (examType === "pyps" || examType === "pypss") {
    subPath = "/pyps";
  } else if (examType === "score") {
    subPath = "/score";
  } else if (examType === "mcts") {
    subPath = "/mcts";
  } else if (
    examType === "revision" ||
    examType === "revisiontest" ||
    examType === "rts"
  ) {
    subPath = "/revision-tests";
  } else if (examType === "cyots" || examType === "cyot") {
    subPath = "/cyot";
  } else if (examType === "cqt" || examType === "cwts") {
    subPath = "/cwts";
  }

  const route: DeeplinkRoute = {
    path: `/${ROUTESWEB.APP.TESTS}${subPath}`,
  };

  if (examType !== "ilts") {
    route.state = {
      autoAttemptTestId: parsed.testId,
      autoAttemptQuestionPaperId: parsed.questionPaperId,
      autoAttemptSeriesId: parsed.seriesId,
    };
  }

  return route;
};
